export default function OptionalLabel() {
    return <small className="text-muted fw-light">(optional)</small>;
}
